module.exports = __webpack_public_path__ + "img/ico_courses.28cfa5cc.png";